import { useState, useEffect } from "react";
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import Sponsor from "../../components/volunteer/Sponsor";
import Donor from "../../components/volunteer/Donor";
import ContentfulUtil from "../../util/ContentfulUtil";

function Sponsors() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const sponsors = await ContentfulUtil.getSponsors();
      setSponsors(sponsors);
    };
    fetchData();
  }, []);

  console.log("pre sponsors", sponsors);
  const formattedSponsors = groupByType(sponsors);

  console.log("Sponsors", formattedSponsors);

  return (
    <>
      <PageTitle>Sponsors & Donors</PageTitle>
      <PageContent>
        <div className="row">
          <div className="col-12">
            <h3>Thank You to Our Sponsors!</h3>
            {formattedSponsors.executive.length > 0 && (
              <>
                <h4 className="sponsorTitle">Executive Sponsors</h4>
                <div>
                  <div className="row justify-content-center">
                    {formattedSponsors.executive.map((sponsor, index) => (
                      <Sponsor
                        key={index}
                        name={sponsor.sponsorName}
                        url={sponsor.sponsorUrl}
                        imgSrc={sponsor.sponsorImage}
                      />
                    ))}
                  </div>
                </div>
                <hr></hr>
              </>
            )}
            {formattedSponsors.premium.length > 0 && (
              <>
                <h4 className="sponsorTitle">Premium Sponsors</h4>
                <div>
                  <div className="row justify-content-center">
                    {formattedSponsors.premium.map((sponsor, index) => (
                      <Sponsor
                        key={index}
                        name={sponsor.sponsorName}
                        url={sponsor.sponsorUrl}
                        imgSrc={sponsor.sponsorImage}
                      />
                    ))}
                  </div>
                </div>
                <hr></hr>
              </>
            )}
            {formattedSponsors.star.length > 0 && (
              <>
                <h4 className="sponsorTitle">Star Sponsors</h4>
                <div>
                  <div className="row justify-content-center">
                    {formattedSponsors.star.map((sponsor, index) => (
                      <Sponsor
                        key={index}
                        name={sponsor.sponsorName}
                        url={sponsor.sponsorUrl}
                        imgSrc={sponsor.sponsorImage}
                      />
                    ))}
                  </div>
                </div>
                <hr></hr>
              </>
            )}
            {formattedSponsors.friend.length > 0 && (
              <>
                <h4 className="sponsorTitle">Friend Sponsors</h4>
                <div>
                  <div className="row justify-content-center">
                    {formattedSponsors.friend.map((sponsor, index) => (
                      <Sponsor
                        key={index}
                        name={sponsor.sponsorName}
                        url={sponsor.sponsorUrl}
                        imgSrc={sponsor.sponsorImage}
                      />
                    ))}
                  </div>
                </div>
                <hr></hr>
              </>
            )}

            <p>
              If you are interested in becoming a <strong>Sponsor</strong>, Please{" "}
              <a href="https://drive.google.com/drive/folders/1kGBrK7sVEGzgi3GSm8r6xeFqaYJ7tu51?usp=sharing">
                CLICK HERE
              </a>
            </p>
            <div className="donateButtons">
              <a
                href="https://images.ctfassets.net/ae4cmm9kc6vt/vm1dfjM0XgoywBeoslgDD/f261a0f60e32b6cb199be769876c351e/Sponsorship_Flyer_2025-26.png"
                target={"_blank"}
                className="btn"
              >
                View Flyer
              </a>
              <img src="https://images.ctfassets.net/ae4cmm9kc6vt/vm1dfjM0XgoywBeoslgDD/f261a0f60e32b6cb199be769876c351e/Sponsorship_Flyer_2025-26.png?h=250"></img>
            </div>
            <p>
              If you are interested in becoming a <strong>Donor</strong>, Please{" "}
              <a href="https://drive.google.com/drive/folders/13MAYiqBAjf9AGODFNsw2N7lytT0RMiCY?usp=sharing">
                CLICK HERE
              </a>
            </p>
            {formattedSponsors.donor.length > 0 && (
              <>
                <h3 className="sponsorTitle" style={{marginBottom:"30px"}}>Thank You to Our Donors!</h3>
                <div>
                  <div className="row justify-content-center">
                    {formattedSponsors.donor.map((sponsor, index) => (
                      <Donor
                        key={index}
                        name={sponsor.sponsorName}
                        url={sponsor.sponsorUrl}
                        imgSrc={sponsor.sponsorImage}
                      />
                    ))}
                  </div>
                </div>
                <hr></hr>
              </>
            )}
          </div>
        </div>
      </PageContent>
    </>
  );
}

function groupByType(arr) {
  const result = {
    executive: [],
    premium: [],
    star: [],
    friend: [],
    donor: [],
  };

  if (!Array.isArray(arr) || arr.length === 0) {
    return result;
  }

  arr.forEach((item) => {
    if (!item?.typeOfSponsor) return;

    const type = item.typeOfSponsor.trim().toLowerCase(); // store in 'type'

    if (type in result) {
      const { typeOfSponsor: _, ...rest } = item; // remove typeOfSponsor
      result[type].push(rest);
    }
  });

  // Sort each array alphabetically by sponsorName
  Object.keys(result).forEach((key) => {
    result[key].sort((a, b) => {
      const nameA = a.sponsorName?.toLowerCase() || "";
      const nameB = b.sponsorName?.toLowerCase() || "";
      return nameA.localeCompare(nameB);
    });
  });

  return result;
}

export default Sponsors;
